import React from "react";

const RussianFlag = (props: any) => {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 120 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      style={{ borderRadius: "50%" }}
    >
      <g clip-path="url(#clip0_706_22849)">
        <path d="M120 0H0V80H120V0Z" fill="#2F80ED" />
        <path d="M120 0H0V26.6667H120V0Z" fill="#F2F2F2" />
        <path d="M120 53.333H0V79.9997H120V53.333Z" fill="#EB5757" />
      </g>
      <defs>
        <clipPath id="clip0_706_22849">
          <rect width="120" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default RussianFlag;
